import { Component } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserLogin } from '../../../../Common/models/user.login';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { Router } from '@angular/router';
import { ManageService } from '../../../../Dashboard/services/manage.service';
import { CustomEncodeDecodeService } from '../../../../Common/services/custom-encode-decode.service';
import { ProjectService } from '../../../services/project.service';


@Component({
  selector: 'app-adhoc-list',
  templateUrl: './adhoc-list.component.html',
  styleUrl: './adhoc-list.component.css'
})
export class AdhocListComponent {

  public adHocList?: any[] = [];
  categoryList: any[] = [];
  selectedCategories: any;
  categoryNames: any = [];
  selectedCategoriesFilter: any[] = [];
  categoryDropdown: any[] = [];
  selectedCategoryDropdown: any[] = [];
  categoryIdCategoryDropdown: any[] = [];
  categoryIdList: any[] = [];
  selectedCategoryIDs: any[] = [];

  categoryFilterList: any[] = [];
  tempVerificationData: any[] = [];
  public selectedVendor: any;
  public userCategoryList: any[] = [];
  converteddata: any;
  searchedProjectTiltle: any;
  selectedDateRange: any;
  selectedStartDate1: string | undefined;
  selectedStartDate2: string | undefined;


  constructor(private projectService: ProjectService, private msgService: MessageService,
    private ngxService: NgxUiLoaderService, private userRoleService: UserRoleServiceService,
    private router: Router, private manageService: ManageService<Blob>,
    private encodeDecodeService: CustomEncodeDecodeService) {
  }

  ngOnInit(): void {
    this.getUserRoleInfo();
    this.getAdhocListData();
  }

  getUserRoleInfo() {
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.categoryList = userRoleInfo.categories;
      this.categoryIdList = this.categoryList.map(res => res.categoryID)
      this.categoryFilterList = this.categoryList.map(res => res.categoryName)
    }
  }

  onProjectTitleChange(event: any) {
    this.filteredProjects();
  }

  onSelectedCategory(event: any) {
    this.selectedCategoriesFilter = event;
    const categoryNames = this.selectedCategoriesFilter.map((x: { categoryName: string }) => x.categoryName.trimEnd()).join(',');
    this.selectedCategories = categoryNames;
    this.filteredProjects();
  }

  onSelectedCategoryDropdown(event: any) {
    this.selectedCategoryDropdown = event;
    this.categoryIdCategoryDropdown = this.categoryList
      .filter(cat => this.selectedCategoryDropdown.includes(cat.categoryName))
      .map(cat => cat.categoryID);
    setTimeout(() => {
    }, 1000);
  }



  getFilterCriteria() {

    const criteria = {
      projectTitle: this.searchedProjectTiltle,
      categoryName: this.selectedCategoriesFilter,
      startDate1: this.selectedStartDate1,
      startDate2: this.selectedStartDate2,
    };

    return criteria;
  }

  getRequestsByCategoryId(categoryId: any) {
    const data = this.tempVerificationData.filter(request =>
      request.adHocRequestCategories.some((cat: { categoryId: any }) => cat.categoryId === categoryId)
    );
  }

  filteredProjects() {

    let criteria = this.getFilterCriteria();
    const categoryIds = criteria.categoryName.map(c => c.categoryID);
    const title = criteria.projectTitle;
    const startDate1 = criteria.startDate1;
    const startDate2 = criteria.startDate2;
    if (categoryIds || title || (startDate1 && startDate2)) {
      this.getAdhocListData(categoryIds, title, startDate1, startDate2);
    }
  }

  applyCategoryDropdown() {
    this.getAdhocListData('', '', '', '', this.categoryIdCategoryDropdown);
    this.categoryDropdown = [];
  }

  getAdhocListData(categoryIDs?: any, title?: any, startDate1?: any, startDate2?: any, categoryIdCategoryDropdown?: any) {
    this.selectedCategoryIDs = categoryIDs;
    if (!categoryIDs && !title && !startDate1 && !startDate2 && !categoryIdCategoryDropdown) {
      this.ngxService.start();
    }

    this.projectService.AdhocList(categoryIDs, title, startDate1, startDate2, categoryIdCategoryDropdown).subscribe({
      next: (res) => {
        if (!categoryIDs && !title && !startDate1 && !startDate2 && !categoryIdCategoryDropdown) {
          this.ngxService.stop();
        }

        this.adHocList = res;
        this.tempVerificationData = JSON.parse(JSON.stringify(this.adHocList));


        const categoryIds = this.adHocList?.flatMap(request =>
          request.adHocRequestCategories?.map((cat: any) => ({ categoryId: cat.categoryId })) || []
        );

        const categoryMap = new Map(
          this.categoryList?.map(cat => [cat.categoryID, cat.categoryName])
        );


        const categoryIdsData = this.adHocList?.map(obj => ({
          categoryIds: obj.adHocRequestCategories.map((cat: { categoryId: any }) => cat.categoryId)
        }));

        this.categoryNames = categoryIdsData?.map(group => ({
          categories: group.categoryIds.map((id: any) => categoryMap.get(id))
        }));
      },
      error: (err) => {
        this.ngxService.stop();
      }
    });
  }


  ExportSalesplanData() {
    let manageDto = {
      categories: this.selectedCategoryIDs ? this.selectedCategoryIDs : this.categoryIdList,
      agencies: [],
      type: "adHoc"
    };
    this.manageService.ExportManageAdHocListExcel(manageDto);
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  selectedSubmittedDateRange() {
    if (this.selectedDateRange == null) {
      this.selectedStartDate1 = undefined;
      this.selectedStartDate2 = undefined;
      this.filteredProjects();
    }
    else if (this.selectedDateRange?.length == 2 && this.selectedDateRange.every((a: any) => a != null)) {
      this.selectedStartDate1 = this.selectedDateRange[0];
      this.selectedStartDate2 = this.selectedDateRange[1];

      if (this.selectedStartDate1) {
        this.selectedStartDate1 = this.formattingDate(this.selectedStartDate1)
      }
      if (this.selectedStartDate2) {
        this.selectedStartDate2 = this.formattingDate(this.selectedStartDate2)
      }
      this.filteredProjects();
    }
  }

  formattingDate(dates: any) {
    const date = new Date(dates);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  editAdhocList(id: number) {
    this.router.navigate(['adhoc/edit', this.encodeDecodeService.encode(id)]);
  }

}
